import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textContainerFn = /* @__PURE__ */ createRecipe('text-container', {}, [])

const textContainerVariantMap = {}

const textContainerVariantKeys = Object.keys(textContainerVariantMap)

export const textContainer = /* @__PURE__ */ Object.assign(memo(textContainerFn.recipeFn), {
  __recipe__: true,
  __name__: 'textContainer',
  __getCompoundVariantCss__: textContainerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textContainerVariantKeys,
  variantMap: textContainerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textContainerVariantKeys)
  },
  getVariantProps: textContainerFn.getVariantProps,
})